import { Alert, Icon, Table } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { getAclManagement, IAgreementRow } from '../../apis/AclManagement';
import EndAgreementModal from './EndAgreementModal';

interface ILocalState {
    resellerName: string,
    errorMessage: string | null,
    loading: boolean,
    activeAgreements: IAgreementRow[],
    selectedAgreementID: number | null,
    showEndAgreementModal: boolean,
}

class AclManagement extends React.Component<RouteComponentProps<any>, ILocalState> {
    public constructor(props: RouteComponentProps<any>) {
        super(props);
        this.state = {
            resellerName: 'undefined',
            errorMessage: null,
            loading: true,
            activeAgreements: [],
            selectedAgreementID: null,
            showEndAgreementModal: false,
        };
    }

    public async componentDidMount() {
        await this.getAclManagement();
    }

    private convertToReadableDate(datetime: string) {
        return new Date(datetime).toLocaleString('utc', {
            timeZone: 'UTC',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }

    private openEndAgreementModal = (e: any) => {
        this.setState({
            selectedAgreementID: e.currentTarget.id,
            showEndAgreementModal: true
        });
    };
    private closeEndAgreementModal = () => this.setState({ selectedAgreementID: null, showEndAgreementModal: false });

    public render() {
        const aclColumns: Array<ColumnProps<IAgreementRow>> = [
            {
                align: 'left',
                className: 'display-linebreaks',
                dataIndex: 'clientName',
                title: 'Client Name',
                width: '20%',
                sorter: (a, b) => {
                    if (a.clientName === b.clientName) {
                        return a.endDate > b.endDate ? -1 : 1;
                    }
                    return (a.clientName > b.clientName) ? -1 : 1;
                },
                sortDirections: ['ascend', 'descend'],
                defaultSortOrder: 'descend',
            },
            {
                align: 'right',
                className: 'display-linebreaks',
                dataIndex: 'clientCompanyID',
                title: 'Client Company ID',
                width: '20%',
                sorter: (a, b) => {
                    if (a.clientCompanyID === b.clientCompanyID) {
                        return a.endDate > b.endDate ? -1 : 1;
                    }
                    return (a.clientCompanyID > b.clientCompanyID) ? -1 : 1;
                },
                sortDirections: ['ascend', 'descend'],
            },
            {
                align: 'right',
                className: 'display-linebreaks',
                dataIndex: 'startDate',
                title: 'Start Date',
                width: '20%',
                render: ((datetime:string) => this.convertToReadableDate(datetime)),
                sorter: (a, b) => a.startDate > b.startDate ? -1 : 1,
                sortDirections: ['ascend', 'descend'],
            },
            {
                align: 'right',
                className: 'display-linebreaks',
                dataIndex: 'endDate',
                title: 'End Date',
                width: '20%',
                render: ((datetime:string) => this.convertToReadableDate(datetime)),
                sorter: (a, b) => a.endDate > b.endDate ? -1 : 1,
                sortDirections: ['ascend', 'descend'],
            },
            {
                align: 'right',
                className: 'display-linebreaks',
                dataIndex: 'agreementID',
                title: 'Cancel',
                width: '20%',
                render: ((id: number) => <a id={id.toString()} onClick={this.openEndAgreementModal}>End Agreement</a>),
            },
        ];

        return (
            <div>
                {this.state.showEndAgreementModal && this.state.selectedAgreementID &&
                    <EndAgreementModal
                        agreementID={this.state.selectedAgreementID}
                        requestClose={this.closeEndAgreementModal}
                    />
                }
                {!this.state.loading &&
                    <div>
                        {this.state.errorMessage &&
                        <Alert className='space-between' message={this.state.errorMessage} type={'error'}/>
                        }
                        <div className='flex charge-history-header space-between'>
                            <h2>
                                <Icon type="calendar"/> ACL Management
                                for {`${this.state.resellerName}`}
                            </h2>
                        </div>
                    </div>
                }
                <div id="active-acl-table">
                    <Table
                        bordered={false}
                        columns={aclColumns}
                        dataSource={this.state.activeAgreements}
                        loading={this.state.loading}
                        pagination={false}
                        rowKey={'agreementID'}
                        rowClassName={this.stripeTableClass}
                        size="small"
                    />
                </div>
            </div>
        );
    }

    private stripeTableClass = (record: any, index: any): string => index % 2 !== 0 ? 'row-stripe' : '';

    private async getAclManagement() {
        const aclManagement = await getAclManagement(this.props.match.params.companyID);
        if (!aclManagement.success) {
            this.setState({
                errorMessage: aclManagement.error,
                loading: false,
            });
        } else {
            this.setState({
                errorMessage: aclManagement.error,
                loading: false,
                resellerName: aclManagement.resellerCompanyName,
                activeAgreements: aclManagement.activeAgreements,
            })
        }
    }
}

export default AclManagement;
